/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const PersonsSearchIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <circle cx="18" cy="18" r="3.5" />
      <line x1="23.5" y1="23.5" x2="20.474" y2="20.475" />
      <polyline points="13.941,13.779 10,12.367 10,10.322" />
      <path d="M6,10.323v2.044 l-3.941,1.412C1.115,14.117,0.5,15.012,0.5,16.012V17.5H11" />
      <path d="M11.947,6.236 c0,2.618-1.768,4.741-3.947,4.741c-2.181,0-3.947-2.123-3.947-4.741C4.053,3.621,5.819,1.5,8,1.5 C10.18,1.5,11.947,3.621,11.947,6.236z" />
      <path d="M11.916,5.811 c-0.132,0.018-0.241,0.006-0.374,0.033c-1.345,0.258-2.208-0.229-2.949-1.525C8.149,5.17,6.762,5.844,5.621,5.844 c-0.562,0-1.045-0.115-1.528-0.369" />
      <path d="M14.5,1.5 c2.18,0,3.947,2.121,3.947,4.736c0,2.618-1.768,4.741-3.947,4.741" />
      <path d="M18.416,5.811 c-0.132,0.018-0.241,0.006-0.374,0.033c-1.345,0.258-2.208-0.229-2.949-1.525" />
      <line x1="16.5" y1="12" x2="16.5" y2="10.322" />
    </g>
  </svg>
);

export default PersonsSearchIcon;
